import * as React from 'react';

import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid,
    TextField, EditButton, ImageField, FunctionField,
    useNotify,useDelete,
    ListProps, Button as RAButton,
    useRecordContext,
    TextInput,
    RichTextField,
    SelectInput,
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IBlog } from '../types/types';
import useAuthorize from '../hooks/useAuthorize';
import { NEWS_PORTAL_ROLES } from './newsRoles';

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<IBlog>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('blogs', { id: record.id });
        notify('resources.blogs.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'News article' }
        });
        setOpen(false);
    };

    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this news article?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};


const blogFilter = [
    <TextInput label="Search title" source="title" resettable alwaysOn/>,
    <SelectInput
        source="status"
        label="Status"
        choices={[
            { id: 'draft', name: 'Draft' },
            { id: 'published', name: 'Published' },
        ]}
        emptyText="All statuses"
        alwaysOn
    />,
];

const formatBlogListDate = (value?: string | null) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString('en-IN', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: 'Asia/Kolkata',
    });
};

const renderBlogPublishedDate = (record?: IBlog) => {
    if (!record) return '—';
    const isPublished = record.status === 'published';
    if (isPublished && record.published_at) {
        return formatBlogListDate(record.published_at);
    }
    const created = formatBlogListDate(record.created_at);
    return created === '—' ? '—' : `Draft · ${created}`;
};

export const BlogList: FC<ListProps> = (props) => {
    useAuthorize(NEWS_PORTAL_ROLES);
    return (
        <List {...props} sort={{ field: "created_at", order: "DESC" }} filters={blogFilter}>
        <Datagrid>
            <ImageField source="image" label="Image" sx={{ '& img': { maxHeight: 56, objectFit: 'cover' } }} />
            <TextField source="title" label="Title" />
            <TextField source="status" label="Status" />
            <FunctionField label="Published" render={renderBlogPublishedDate} />
            <TextField source="source" label="Source" />
            <RichTextField source="description" label="Description" />
            <EditButton />
            <DeleteWithConfirmButton />
        </Datagrid>
    </List>
    );
};